const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const BOOKING_API = 'https://bookpadelarena.ch/api';
export const BOOKING_URL = 'https://bookpadelarena.ch';

export const SITE_URL = 'https://www.padelarena.ch';

export const FEATURED_EVENT_FLYER = 'https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/ocjnzsxf_Green%20Colorful%20Travel%20Hiking%20Adventure%20Booking%20Flyer%20%285%29.png';

export const WHATSAPP_LINKS = {
  community: "aHR0cHM6Ly9jaGF0LndoYXRzYXBwLmNvbS9HbEJYMzA1b0pGWUQ2U3lGeFRHS3N4",
  booking:   "aHR0cHM6Ly93YS5tZS80MTc5OTE2MDgzND90ZXh0PUhhbGxvISUyMEljaCUyMGJpbiUyMGFuJTIwUGFkZWwtVHJhaW5pbmdzJTIwaW50ZXJlc3NpZXJ0JTIwdW5kJTIwbSVDMyVCNmNodGUlMjBtZWhyJTIwJUMzJUJDYmVyJTIwZGllJTIwTSVDMyVCNmdsaWNoa2VpdGVuJTIwZXJmYWhyZW4uJTIwV2llJTIwc29sbCUyMGljaCUyMHZvcmdlaGVuJTNG",
  contact:   "aHR0cHM6Ly93YS5tZS80MTc5OTE2MDgzND90ZXh0PUhpJTIxJTIwSSUyMGhhdmUlMjBhJTIwcXVlc3Rpb24lMjBhYm91dCUyMFBhZGVsYXJlbmEu"
};

// Base64-encoded WhatsApp number (hidden from HTML source for bot protection) — +41 79 916 0834
export const WA_PHONE_B64 = "NDE3OTkxNjA4MzQ=";
